import { IIncentiveContract } from "../../../services/zeos-api/contracts/Incentive";

export const filterRealIncentives = (incentives: IIncentiveContract[]) =>
    incentives.filter(
      (incentive) =>
        incentive.incentiveId > 0 &&
        incentive.incentiveProgramId > 0 &&
        Boolean(incentive.name?.trim())
    );